import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";

/**
* @class Merchant
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.transactions[0];
* const merchant = new merchant(record);
* @property {STRING} _id -number to reference the merchant
* @property {STRING} _logo - name of logo for merchant
* @property {STRING} _name - name of merchant
* @property {STRING} _group - group to sort the merchant
* @property {STRING} _groupLogo- what logo to include for the group
* @property {STRING} _street - street address for merchant
* @property {STRING} _city - city address for merchant
* @property {STRING} _state - state address for merchant
* @property {STRING} _zip - zip code address for merchant
* @property {STRING} _country - country address for merchant
* @property {STRING} _phone - merchants phone number
* @property {STRING} _email - email
*/

export default class Merchant extends BCMSRecord {
    _id 
    _logo
    _name
    _group
    _groupLogo
    _street
    _city
    _state
    _zip
    _country
    _phone
    _email

  constructor(record) {
    super(record)
  }
}
Merchant.define({
  "recordType": "merchant",
  "recordIDProp": "id",
  "className" : "Merchant",
  "recordProperties": [    
   
   /** 
    * @name id
    * @instance
    * @property get {STRING} - gets the id of the merchant
    * @property set {STRING} - sets the id of the merchant
    * @memberof merchant 
    */

    BCMSRecordProperty.mapToString("id", "_id"),
   
    /** 
     * @name logo
     * @instance
     * @property get {STRING} - gets the logo of the merchant
     * @property set {STRING} - sets the logo of the merchant
     * @memberof merchant 
     */

     BCMSRecordProperty.mapToString("logo", "_logo"),

    /** 
     * @name name
     * @instance
     * @property get {STRING} - gets the name of the merchant
     * @property set {STRING} - sets the name of the merchant
     * @memberof merchant 
     */

    BCMSRecordProperty.mapToString("name", "_name"),
    /** 
     * @name group
     * @instance
     * @property get {STRING} - gets the group of the merchant
     * @property set {STRING} - sets the group of the merchant
     * @memberof merchant 
     */

    BCMSRecordProperty.mapToString("group", "_group"),
   
    /** 
     * @name groupLogo
     * @instance
     * @property get {STRING} - gets the groupLogo of the merchant
     * @property set {STRING} - sets the groupLogo of the merchant
     * @memberof merchant 
     */

    BCMSRecordProperty.mapToString("groupLogo", "_groupLogo"),

   /** 
    * @name street
    * @instance
    * @property get {STRING} - gets the street of the merchant
    * @property set {STRING} - sets the street of the merchant
    * @memberof merchant 
    */

    BCMSRecordProperty.mapToString("street", "_street"),
    
   /** 
    * @name city
    * @instance
    * @property get {STRING} - gets the city of the merchant
    * @property set {STRING} - sets the city of the merchant
    * @memberof merchant 
    */

    BCMSRecordProperty.mapToString("city", "_city"),
   
   
    /** 
     * @name state 
     * @instance
     * @property get {STRING} - gets the state  of the merchant
     * @property set {STRING} - sets the state  of the merchant
     * @memberof merchant 
     */

    BCMSRecordProperty.mapToString("state", "_state"),
      
   /** 
    * @name zip
    * @instance
    * @property get {STRING} - gets the zip of the merchant
    * @property set {STRING} - sets the zip of the merchant
    * @memberof merchant 
    */   

    BCMSRecordProperty.mapToString("zip", "_zip"),
      
    /** 
     * @name country
     * @instance
     * @property get {STRING} - gets the country of the merchant
     * @property set {STRING} - sets the country of the merchant
     * @memberof merchant 
     */

    BCMSRecordProperty.mapToString("country", "_country"),
    /** 
     * @name phone
     * @instance
     * @property get {STRING} - gets the phone of the merchant
     * @property set {STRING} - sets the phone of the merchant
     * @memberof merchant 
     */

     BCMSRecordProperty.mapToString("phone", "_phone"),
     /** 
     * @name email
     * @instance
     * @property get {STRING} - gets the email of the merchant
     * @property set {STRING} - sets the email of the merchant
     * @memberof merchant 
     */
    BCMSRecordProperty.mapToString("email", "_email"),
      
    /** 
     * @name description
     * @instance
     * @property get {STRING} - gets the description of the merchant
     * @property set {STRING} - sets the description of the merchant
     * @memberof merchant 
     */
    BCMSRecordProperty.mapToString("description", "_description")
  ]
})
